var map = {
	"./project/icons/cursor_360.svg": "6a45",
	"./project/icons/icon_360_black.svg": "ce56",
	"./project/icons/icon_360_white.svg": "b39e",
	"./project/icons/location.svg": "4031",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";